<template>
    <!-- Features -->
    <div class="bg-soft-warning" :id="'Q'+idQuestion" v-if="idQuestion == ActiveQuestion">
    <div class="progress" style="height:50px; font-size:15pt;" v-if="porcentajeCompletado>=60">
        <div class="progress-bar progress-bar-striped progress-bar-animated" id="ProgresoFormulario" role="progressbar" :aria-valuenow="porcentajeCompletado" aria-valuemin="0" aria-valuemax="100" :style="EstiloBarra">

           <span style="padding-right:15px; font-size: 10pt;"> Has Completado el <b>{{porcentajeCompletado}}</b>% </span>

        </div>
    </div>
        <div class="container" id="PreguntaFormulario">
            <!-- Heading -->
            <div class="w-lg-65 text-center mx-lg-auto mb-7" id="formularioContenedor">
                <h1 class="h4 tituloFormulario" style="font-weight: normal;" v-html="question"></h1>
                <p class="fs-8" v-html="help"></p>
                <p class="fs-8" style="color:red;" v-if="errorMsg && validate == false">{{errorMsg}}</p>

            </div>
            <!-- End Heading -->

            <SelectOne 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response" 
            :answers="answers" 
            v-if="tipo == 'SelectOne'"></SelectOne>

            <AlgoliaSearchOne 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response" 
            :AlgoliaApiKey="AlgoliaApiKey"
            :AlgoliaUser="AlgoliaUser" 
            :indexAlgolia="indexAlgolia"
            :AlgoliaRefQuestion="AlgoliaRefQuestion"
            :AlgoliaRefHelp="AlgoliaRefHelp"
            :AlgoliaRefData="AlgoliaRefData"
            :placeholder="placeHolder"
            :answers="answers"
            v-if="tipo == 'AlgoliaSearchOne'"></AlgoliaSearchOne>

            <Iban 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response" 
            v-if="tipo == 'Iban'"></Iban>

            <Email 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :lopd="lopd" 
            v-if="tipo == 'Email'"></Email>

           <DireccionPostal 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :allresponses="allresponses"
            v-if="tipo == 'DireccionPostal'"></DireccionPostal>

           <NombreCompleto 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :allresponses="allresponses"
            v-if="tipo == 'NombreCompleto'"></NombreCompleto>

           <NIF 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :allresponses="allresponses"
            v-if="tipo == 'NIF'"></NIF>

           <Texto 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :placeHolder="placeHolder"
            v-if="tipo == 'Texto'"></Texto>


           <Telefono 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :placeHolder="placeHolder"
            v-if="tipo == 'Telefono'"></Telefono>
            
           <Fecha 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :maxDate="maxDate"
            :minDate="minDate"
            v-if="tipo == 'Fecha'"></Fecha>

            <FechaEfectoAsisaSalud 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :maxDate="maxDate"
            :minDate="minDate"
            v-if="tipo == 'FechaEfectoAsisaSalud'"></FechaEfectoAsisaSalud>

           <Firma 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :placeHolder="placeHolder"
            :lopd="lopd" 
            v-if="tipo == 'Firma'"></Firma>

            <Pricing 
            :idQuestion="idQuestion" 
            :FormularioTag="FormularioTag" 
            :response="response"
            :PeriodoSeleccionado="PeriodoSeleccionado"
            :PrecioProducto="PrecioProducto"
            :PeriodosEscritos="PeriodosEscritos"
            :productoAnterior="productoAnterior"
            :PricingProducts="PricingProducts"
            :ProductoSeleccionado="ProductoSeleccionado"
            :AddonsSeleccionados="AddonsSeleccionados"
            :Precios="Precios"

            v-if="tipo == 'Pricing'"></Pricing>

            <div class="w-lg-65 mx-lg-auto content-space-1" id="ControlFormulario">
                <div class="row text-center">
                    <span class="col-6 text-left">
                        <button type="button" class="text-center btn btn-soft-primary btn-lg" @click="IrAtrasFormulario()" v-if="ActiveQuestion && loading == false">Atrás</button>
                        <button type="button" class="text-center btn btn-soft-primary btn-lg" disabled="true" v-if="ActiveQuestion && loading == true">Atrás</button>

                    </span>
                    <span class="col-6 text-right">
                        <button type="button" v-if="response==null || validate == false" disabled="true" class="text-center btn btn btn-primary btn-lg">Siguiente</button>
                        <button type="button" v-if="response != null && loading == false && validate == true" class="text-center btn btn btn-primary btn-lg" @click="IrHaciaDelanteFormulario()">
                            Siguiente
                        </button>

                        <template v-if="response != null && loading == true">


                            <button type="button"  disabled="true" class="btn btn btn-primary btn-lg">

                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="sr-only" style="padding-left:10px;">Cargando...</span>

                            </button>

                            <PantalladeCarga :titulo="textoPantallaCarga"></PantalladeCarga>


                        </template>



                    </span>

                </div>
            </div>

        </div>
    </div>
</template>

<script>

import SelectOne from './SelectOne.vue'
import AlgoliaSearchOne from './AlgoliaSearchOne.vue'
import Iban from './Iban.vue'
import Email from './Email.vue'
import DireccionPostal from './DireccionPostal.vue'
import NombreCompleto from './NombreCompleto.vue'
import NIF from './NIF.vue'
import Texto from './Texto.vue'
import Telefono from './Telefono.vue'
import Fecha from './Fecha.vue'
import Firma from './Firma.vue'
import Pricing from './Pricing.vue'
import PantalladeCarga from './PantalladeCarga.vue'
import FechaEfectoAsisaSalud from './FechaEfectoAsisaSalud.vue'


export default {
    name: 'General',
    components : { SelectOne, AlgoliaSearchOne, Iban, Email, DireccionPostal, NombreCompleto, NIF, Texto, Telefono, Fecha, Firma, Pricing, PantalladeCarga, FechaEfectoAsisaSalud},
    props: {
        idQuestion: Number,
        tipo : String,
        question : String,
        help: String,
        response: {
            type: [Number, String]
        },
        answers: Array,
        FormularioTag: String,
        ActiveQuestion: Number,
        AlgoliaApiKey: String,
        AlgoliaUser: String,
        indexAlgolia: String,
        AlgoliaRefQuestion: String,
        AlgoliaRefHelp: String,
        AlgoliaRefData: String,
        errorMsg: String,
        validate: Boolean,
        allresponses: Object,
        placeHolder: String,
        minDate: String,
        maxDate: String,
        loading: Boolean,
        NumberQuestions: Number,
        PeriodoSeleccionado: String,
        PrecioProducto: Number,
        PeriodosEscritos: Object,
        productoAnterior: Boolean,
        PricingProducts: Array,
        ProductoSeleccionado: String,
        AddonsSeleccionados: Array,
        lopd: String,
        textoPantallaCarga: String,
        Precios : Array

    },

    data: function(){

        return {

            porcentajeCompletado: 0,
            EstiloBarra: {

                "width": "75%",
                "text-align": "right"
            }

        }

    },
    
    mounted: function(){


        this.porcentajeCompletado = Math.floor((this.idQuestion/this.NumberQuestions)*100);;

        this.EstiloBarra.width = this.porcentajeCompletado+'%';


    },


    methods : {

    IrAtrasFormulario : function(){

        this.MostrarTituloSiempre();
        this.$store.commit('IrAtrasFormulario', this.FormularioTag);

    },


    IrHaciaDelanteFormulario : function(){

        this.MostrarTituloSiempre();
        this.$store.commit('IrHaciaDelanteFormulario', this.FormularioTag);


    },

    MostrarTituloSiempre: function(){

        window.scrollTo(0, 0);

    }
    

    },
}
</script>

<style scoped>
    #formularioContenedor {

        animation-name: anirmarFormulario;
        animation-duration: 0.5s;
    }


    @keyframes anirmarFormulario {
        0%   {padding-top:50px;}
        40% {padding-top:100px;}
        80% {padding-top:50px;}
        100% {}

    }

    @media only screen and (min-width: 768px) {
        #formularioContenedor {

            padding-top:150px;

        }

        #PreguntaFormulario {

            padding-bottom:1024px;
        }
    }

    @media only screen and (max-width: 768px) {
        
        #formularioContenedor {

            padding-top:50px;

        }

        #PreguntaFormulario {

            padding-bottom:400px;
        }
    }

</style>